export default {
  upload: uploadOpts => {
    let param = new FormData()

    let data = uploadOpts.data

    if (typeof data === 'object') {
      for (let key in data) {
        param.append(key, data[key])
      }
    }

    param.append('file', uploadOpts.file)

    return {
      url: uploadOpts.action,
      method: 'POST',
      data: param,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/apis/modules/Upload.js